import { useEffect, useMemo } from "react";
import { useTimer } from "react-timer-hook";

import { formatTime } from "@/shared-utils/formatters";

import { ElapsedTimeValue } from "./ElapsedTimeValue";

export function CountdownTimer({ endAt, includeUnit = false }: { endAt: number; includeUnit?: boolean }) {
    const expiryDate = useMemo(() => new Date(endAt), [endAt]);
    const { totalSeconds, restart } = useTimer({ expiryTimestamp: expiryDate });
    const formattedTimeLeft =
        totalSeconds >= 60
            ? formatTime(totalSeconds, includeUnit, "m:ss")
            : formatTime(totalSeconds, includeUnit, "ss");
    const [timeValue, timeUnit] = formattedTimeLeft.split(" ");

    useEffect(() => {
        restart(expiryDate);
    }, [endAt, expiryDate, restart]);

    return <ElapsedTimeValue value={timeValue} unit={timeUnit} size="xxs" />;
}
